// extracted by mini-css-extract-plugin
export default {"empty":"index_empty__RllIA","text":"index_text__K0ziA"};